export default __webpack_public_path__ + "static/media/40.9124d40f.jpg";